module.exports = __webpack_public_path__ + "static/high_performer_enterprise-0a380798b3f8c315770e2b03673f8084.svg";